export default __webpack_public_path__ + "static/media/stancare02.742aa7c9.png";